import { NavigationMode, NavigationPeriodId } from '@atlassian/eoc-schedule-common';

import type { ScheduleEntity } from '../../../services/endpoints/list/types';

import type { ScheduleStore } from './types';

export const initialState: ScheduleStore = {
	addOverrideLoading: false,
	revertOverrideLoading: false,
	getTimelineLoading: true,
	selectedView: NavigationMode.Timeline,
	takeOnCallLoading: false,
	timelineData: undefined,
	calendarData: undefined,
	timelineType: NavigationPeriodId.TwoWeeks,
	currentDate: undefined as unknown as Date,
	schedule: undefined as unknown as ScheduleEntity,
};
